import Hero from "@/components/Hero";
import About from "@/components/About";

import News from "@/components/News";
import PhotoCollage from "@/components/PhotoCollage";
import ParallaxDivider from "@/components/ParallaxDivider";
import RentVenue from "@/components/RentVenue";
import JoinUs from "@/components/JoinUs";
import PageSeo from "@/components/PageSeo";

const Index = () => {
  return (
    <>
      <PageSeo
        title="Luther Club Kaiserslautern – Nachtclub & Events"
        description="Luther Club Kaiserslautern: Nachtclub für Events, Party und Afterwork in der Martin-Luther-Straße 8. Jeden Freitag & Samstag geöffnet."
        path="/"
      />
      <Hero />
      <About />
      
      <News />
      <PhotoCollage />
      <ParallaxDivider image="/images/parallax-3.webp" />
      <RentVenue />
      <ParallaxDivider
        image="/images/parallax-1.webp"
        sideImages={["/images/parallax-left.avif", "/images/parallax-right.avif"]}
      />
      <JoinUs />
    </>
  );
};

export default Index;
